import StripeLinkStep from '@molecules/StripeLinkStep';
import { StripeRequiredInfo } from '@molecules/StripeRequiredInfo';
import useTeams from '@hooks/useTeams';
import { CircularProgress, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { TeamForm } from '@components/teamCreation/CreateTeamUtils';

// manage team payment
export default function TeamPaymentConfig() {
    // edit payment admins
    // view payment reporting
    // view failed payments
    // view successful payments?
    // link to stripe dashboard

    const { selectedTeam, stripePaymentUser, stripeState } = useTeams();
    const { watch } = useFormContext<TeamForm>();
    const [teamId] = watch(['id']);

    if (stripeState?.loading) {
        return (
            <div style={{ textAlign: 'center', padding: '5rem' }}>
                <CircularProgress />
            </div>
        );
    }

    if (!stripePaymentUser?.stripeId) {
        return <Typography>Stipe account loading or not connected successfully</Typography>;
    }

    return (
        <div>
            <StripeRequiredInfo connectedAccountId={stripePaymentUser.stripeId} />
            <StripeLinkStep
                connectedAccountId={
                    (teamId === selectedTeam?.id && stripePaymentUser?.stripeId) || ''
                }
            />
        </div>
    );
}
